import { NgModule } from '@angular/core';
import { MeComponent } from './me.component';
import { BaseModule } from '../shared/base.module';
import { StoryBlokLinkModule } from '../shared/storyblok/link/link.module';
import { LandingPageModule } from './landing-page/landing-page.module';
import { MeRoutesModule } from './me.routes';
import { MeHeaderModule } from './me-header/me-header.module';
import { MeFooterModule } from './me-footer/me-footer.module';
import { MeLandingPageFooterModule } from './landing-page-footer/landing-page-footer.module';
import { MeLandingPageHeaderModule } from './landing-page-header/landing-page-header.module';
import { FooterNonMedicalModule } from './footer-non-medical/footer-non-medical.module';
import { MeLanguageSwitchModule } from './language-switch/language-switch.module';

@NgModule({
    imports: [
        BaseModule,
        LandingPageModule,
        MeRoutesModule,
        MeHeaderModule,
        MeLandingPageHeaderModule,
        MeFooterModule,
        MeLandingPageFooterModule,
        FooterNonMedicalModule,
        StoryBlokLinkModule,
        MeLanguageSwitchModule,
    ],
    declarations: [
        MeComponent
    ]
})
export class MeModule { }
